import React from "react";
// import { useEffect, useState } from "react";
// import { useMutation } from "react-query";
// import { useSelector } from "react-redux";
import NewDashboardLayout from "../../component/layout/NewDashboardLayout";
import DashboardPageBottom from "./DashboardPageBottom";
import DashboardTop from "./DashboardTopSection";
// import WalletMaintenanceFeeModal from "../../component/dashboard/WalletMaintenanceFeeModal";
// import { handleMarkAsViewedMaintenanceFeeInformation } from "../../api/onboarding";

export default function Dashboard() {
  // const [showFeeModal, setShowFeeModal] = useState(false);
  // const { business, isLoading } = useSelector((store) => store || {});

  // const { mutate: markFeeInformationViewed } = useMutation({
  //   mutationFn: handleMarkAsViewedMaintenanceFeeInformation,
  //   mutationKey: ['mark-fee-information-viewed'],
  // });

  // const hasViewedMaintenanceFeeInformation = business?.hasViewedMaintenanceFeeInformation;
  // const isApprovedBusinees = business?.status === 'APPROVED';

  // useEffect(() => {
  //   if (isLoading || !isApprovedBusinees) return;
  //   setShowFeeModal(!hasViewedMaintenanceFeeInformation);
  // }, [hasViewedMaintenanceFeeInformation, isLoading, isApprovedBusinees]);

  // const handleFeeModalClose = () => {
  //   markFeeInformationViewed();
  //   setShowFeeModal(false);
  // };

  return (
    <NewDashboardLayout>
      <DashboardTop />
      <DashboardPageBottom />

      {/* {showFeeModal && (
        <WalletMaintenanceFeeModal
          isOpen={showFeeModal}
          onClose={handleFeeModalClose}
          onLearnMore={() => {
            window.open("https://tradevu.zohodesk.com/portal/en/kb/articles/understanding-wallet-maintenance-fees", "_blank");
          }}
        />
      )} */}
    </NewDashboardLayout>
  );
}
